import { GTMEvent } from '../GTM'
import { formatPrice } from '@corratech/pylot-seo'
import { itemHasKeys, deepValue } from '@corratech/pylot-utils'
import { getCategoryName, getItemCategoryName } from '../mapping/functions'

export type GTMProductData = {
    name: string
    id: string
    price: number
    currencyCode?: string
    category?: string
    categoryPath?: string
    brand?: string
    product_type?: string
    is_sale_item?: string
    brand_text?: string
    categories?: Array<{ name?: string }>
    attribute_set_name?: string
}

export const isValidProductItemData = (
    data: unknown
): data is GTMProductData => {
    return itemHasKeys(data, ['name', 'id', 'price'])
}

const getItemCategory2 = (data: GTMProductData): string => {
    const attributeSet = deepValue(data, ['attribute_set_name'], '') as string
    if (attributeSet) {
        return attributeSet
    }

    const categories = deepValue(data, ['categories'], [])
    if (Array.isArray(categories) && categories.length > 0) {
        return deepValue(categories[0], ['name'], '') as string
    }

    return ''
}

const getItemCategory = (data: GTMProductData): string => {
    const itemCategory = getItemCategoryName(data as any)
    if (itemCategory) {
        return itemCategory
    }

    return getCategoryName(data as any) || ''
}

export const pushPdp = (data: Record<string, unknown>): GTMEvent => {
    if (!isValidProductItemData(data)) {
        console.info('Invalid GTM PDP data')
        return { event: '' }
    }

    const {
        category,
        name,
        id,
        price,
        currencyCode,
        categoryPath,
        brand,
        is_sale_item,
        brand_text
    } = data

    const itemCategory = getItemCategory(data)
    const itemCategory2 = getItemCategory2(data)

    return {
        event: 'product',
        ecommerce: {
            detail: {
                actionField: {
                    list: category ? `Category - ${category}` : ''
                },
                products: [
                    {
                        name,
                        id,
                        price: formatPrice(Number(price)),
                        currency_code: currencyCode,
                        item_category: itemCategory || categoryPath,
                        item_category2: itemCategory2,
                        brand: brand_text
                    }
                ]
            }
        },
        is_sale_item,
        _clear: true
    }
}
